import React from 'react';
import {gql} from '@apollo/client';
import {get, uniqBy} from 'lodash';

import client from '../../../../../src/graphql/client';
import refactorFinanceRates from '../../../../../src/data-restructure/data/repayment-calc-rates';
import financeRatesQuery from '../../../../../src/graphql/queries/finance-rates';
import ForSaleContainer from '../../../../../src/containers/ForSale';
import contentBuilderQuery from '../../../../../src/graphql/queries/content-builder';
import refactorContentBuilderData from '../../../../../src/data-restructure/contentBuilder';
import toTitleCase from '../../../../../src/util/toTitleCase';
import getStateName from '../../../../../src/util/getStateName'; 
import stockPageCalcQuery from '../../../../../src/graphql/queries/pages/stock-page-calc';
import stockCalcRestructure from '../../../../../src/data-restructure/pages/stock-calc';

// queries
import seoQuery from '../../../../../src/graphql/queries/seo';

const ForSaleRegion = (props) => {
  return (
    <ForSaleContainer 
      {...props}
    />
  )
}

export default ForSaleRegion // withWidth(ForSaleRegion);

export async function getStaticPaths() {

  if (process.env.DEALER_SITE) {
    return { paths: [], fallback: 'blocking' }
  }
  
  const GET_DYNAMIC_PATHS_QUERY = gql`
    query GET_DYNAMIC_PATHS {
      stockPages(first: 10000) {
        nodes {
          acf_stock_page {
            range
            state
            region
          }
        }
      }
    }
  `

  const result = await client.query({
    query: GET_DYNAMIC_PATHS_QUERY
  });

  const ranges = get(result, 'data.stockPages.nodes', []);
  let paths = [];
  
  const filteredRanges = ranges.filter((item) => {
    // filter out if doesn't have uri
    return (item.acf_stock_page.state && item.acf_stock_page.range && item.acf_stock_page.region)
  });
  
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  const domain = countryCode === 'au' ? 'jayco.com.au' : 'jayco.co.nz';


  filteredRanges.forEach(range => {
    const assignedDomains = ['jayco.com.au'] // Aus only
    assignedDomains.indexOf(domain) !== -1 && paths.push({
      params: {
        range: `${range.acf_stock_page.range}`,
        state: `${range.acf_stock_page.state}`,
        region: `${range.acf_stock_page.region}`
      }
    });
  })

  return { paths , fallback: 'blocking' }
}


export async function getStaticProps(context) {
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  
  const {
    params
  } = context

  const GET_DYNAMIC_RANGE_PROPS = gql`
    query GET_RANGE_DATA($uri: String) {
      stockPages(first: 10000) {
        nodes {
          id
          title
          seo {
            ${seoQuery}
          }
          acf_domains {
            assignedDomains
          }
          acf_stock_page {
            range
            offRoad
            state
            region
            postcodes
          }
          ${contentBuilderQuery('StockPage_AcfContentBuilder')}
        }
      }
      ${financeRatesQuery}
      ${stockPageCalcQuery('au')}
    }
  `
  const pageData = await client.query({
    query: GET_DYNAMIC_RANGE_PROPS,
  });

  const calculatorModal = stockCalcRestructure(get(pageData, 'data', []));

  const pageProps = get(pageData, 'data.stockPages.nodes', []).find(item => {
    return get(item, 'acf_stock_page.range', '').replace(' ', '-').toLowerCase() === params.range.replace(' ', '-').toLowerCase() && get(item, 'acf_stock_page.state', null) && get(item, 'acf_stock_page.state', '').replace(' ', '-').toLowerCase() === params.state.replace(' ', '-').toLowerCase() && get(item, 'acf_stock_page.region', null) && get(item, 'acf_stock_page.region', '').replace(' ', '-').toLowerCase() === params.region.replace(' ', '-').toLowerCase()
  });

  const categories = uniqBy(get(pageData, 'data.stockPages.nodes', []).map(cat => {
    return get(cat, 'acf_stock_page.range', null)
  }))

  // seo
  const title = get(pageProps, 'title', null);
  const seo = get(pageProps, 'seo', null);
  const assignedDomains = ['jayco.com.au'] // get(pageProps, 'data.acf_domains.assignedDomains', []); 

  const meta = {
    title,
    seo,
    assignedDomains
  };

  const rates = refactorFinanceRates(pageData, countryCode);

  const cbData = pageProps ? await refactorContentBuilderData(pageProps, null, 'StockPage') : null;
  const breadcrumbs = {
    list: [
      {
        link: {
            title: 'Home',
            href: '/',
            target: '_self',
            assignedDomains
        },
        active: false
      },
      {
        link: {
            title: 'Search',
            href: '/for-sale',
            target: '_self',
            assignedDomains
        },
        active: false
      },
      {
        link: {
            title: `${toTitleCase(params.range.replace('-', ' '))} for Sale`,
            href: `/for-sale/${params.range}`,
            target: '_self',
            assignedDomains
        },
        active: false
      },
      {
        link: {
          title: `${getStateName(params.state)}`,
          href: `/for-sale/${params.range}/${params.state}`,
          target: '_self',
          assignedDomains
        },
        active: false
      },      {
        link: {
          title: `${toTitleCase(params.region.replace('-', ' '))}`,
          href: `/for-sale/${params.range}/${params.state}/${params.region}`,
          target: '_self',
          assignedDomains
        },
        active: true
      }
    ]
  };

  return {
    revalidate: (process.env.NEXT_STATIC_EXPORT && process.env.NEXT_STATIC_EXPORT.toString() === 'true') ? false : 1,
    props: {
      meta,
      title: `[range] for sale in ${params.region.split('-').join(' ')}`,
      range: params.range.replace('-', ' '), 
      region: params.region.toUpperCase(),
      state: params.state.toUpperCase(),
      rates,
      breadcrumbs,
      categories,
      contentBuilder: cbData,
      footerDisclaimer: rates.disclaimer,
      calculatorModal
    }
  }
}
